import { useState } from "react";
import { AppBar, Box, IconButton, Toolbar, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useTranslation } from "react-i18next";
import "./NavBar.css";
import { useNavigate } from "react-router-dom";
import { appConfig } from "../../utils/config";
import { availableLanguages } from "../../i18n";
import { languageLabels } from "../../utils/formUtils";
import { useLogout } from "../../hooks/useLogout";

export const Header = ({ toggleSidebar }) => {
  const { t, i18n } = useTranslation();
  const [langOpen, setLangOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const navigate = useNavigate();
  const logout = useLogout();

  const handleProfile = () => {
    navigate("/profilepage");
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("appLng", lng);
    setLangOpen(false);
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor:
          appConfig.client === "CLIENT_C" ? "#ffffff" : "var(--main-color)",
        color: appConfig.client === "CLIENT_C" ? "#000000" : "white",
      }}
    >
      <Toolbar
        sx={{
          minHeight: "80px",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", minWidth: 0 }}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={toggleSidebar}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h5"
            sx={{
              ml: 2,
              color: appConfig.client === "CLIENT_C" ? "#000" : "white",
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              fontSize: { xs: "1rem", sm: "1.5rem" },
            }}
          >
            {t(`clients.${appConfig.client}.title`)}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            flexShrink: 0,
          }}
        >
          <div
            className="language-selector"
            onMouseLeave={() => setLangOpen(false)}
          >
            <button
              className="dropdown-button"
              onClick={() => setLangOpen((open) => !open)}
              style={{
                color: appConfig.client === "CLIENT_C" ? "black" : "undefined",
              }}
            >
              {t(languageLabels[i18n.language] || "navbar.english")}
              <div className="arrowLanguage">
                <KeyboardArrowDownIcon fontSize="small" sx={{}} />
              </div>
            </button>
            {langOpen && (
              <ul className="dropdown-menu">
                {availableLanguages.map(({ code, label }) => (
                  <li key={code}>
                    <button type="button" onClick={() => changeLanguage(code)}>
                      {label}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div
            className="profileSelector"
            onMouseLeave={() => setProfileOpen(false)}
          >
            <IconButton
              color="inherit"
              sx={{ paddingInline: "1rem" }}
              onClick={() => setProfileOpen((open) => !open)}
              className="dropdown-button"
              aria-label="navbar.profile"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                fill="currentColor"
                className="bi bi-person-fill-gear"
                style={{
                  color:
                    appConfig.client === "CLIENT_C"
                      ? "var(--main-color)"
                      : "white",
                }}
                viewBox="0 0 16 16"
              >
                <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-9 8c0 1 1 1 1 1h5.256A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1 1.544-3.393Q8.844 9.002 8 9c-5 0-6 3-6 4m9.886-3.54c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382zM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0" />
              </svg>
            </IconButton>
            {profileOpen && (
              <ul className="dropdown-menu">
                <li>
                  <button type="button" onClick={() => handleProfile()}>
                    {t("navbar.profile")}
                  </button>
                </li>
                <li>
                  <button type="button" onClick={() => logout()}>
                    {t("navbar.logout")}
                  </button>
                </li>
              </ul>
            )}
          </div>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
